import { api } from './client';
import { Reservation, Room } from './reservations';

export interface CalendarDay {
  date: string;
  reservations: Reservation[];
}

export interface CalendarRoom {
  roomId: string;
  roomAddress: string;
  roomType: string;
  days: CalendarDay[];
}

export interface CalendarData {
  year: number;
  month: number;
  dates: string[];
  rooms: CalendarRoom[];
}

export interface DuplicateInfo {
  roomId: string;
  date: string;
  reservations: string[];
}

export const calendarApi = {
  getMonthlyCalendar: async (year: number, month: number) => {
    const response = await api.get(`/calendar/${year}/${month}`);
    return response.data.data as CalendarData;
  },

  getDuplicateReservations: async (year: number, month: number) => {
    const response = await api.get(`/calendar/duplicates/${year}/${month}`);
    return response.data.data as DuplicateInfo[];
  },

  updateByDragDrop: async (data: {
    reservationId: string;
    newCheckinDate?: string;
    newCheckoutDate?: string;
    newRoomId?: string;
  }) => {
    const response = await api.put('/calendar/dragdrop', data);
    return response.data.data as Reservation;
  },
};
